var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileinputIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 3,
    fill: "#54A8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3351 14.5716C13.7725 14.5716 14.127 14.2197 14.127 13.7858C14.127 13.3518 13.7725 13 13.3351 13C12.8978 13 12.5433 13.3518 12.5433 13.7858C12.5433 14.2197 12.8978 14.5716 13.3351 14.5716Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8784 14.5716C19.3157 14.5716 19.6703 14.2197 19.6703 13.7858C19.6703 13.3518 19.3157 13 18.8784 13C18.441 13 18.0865 13.3518 18.0865 13.7858C18.0865 14.2197 18.441 14.5716 18.8784 14.5716Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79189 14.5716C8.22924 14.5716 8.58379 14.2197 8.58379 13.7858C8.58379 13.3518 8.22924 13 7.79189 13C7.35454 13 7 13.3518 7 13.7858C7 14.2197 7.35454 14.5716 7.79189 14.5716Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3351 14.5716C13.7725 14.5716 14.127 14.2197 14.127 13.7858C14.127 13.3518 13.7725 13 13.3351 13C12.8978 13 12.5433 13.3518 12.5433 13.7858C12.5433 14.2197 12.8978 14.5716 13.3351 14.5716Z",
    stroke: "white",
    strokeWidth: 2.30328,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8784 14.5716C19.3157 14.5716 19.6703 14.2197 19.6703 13.7858C19.6703 13.3518 19.3157 13 18.8784 13C18.441 13 18.0865 13.3518 18.0865 13.7858C18.0865 14.2197 18.441 14.5716 18.8784 14.5716Z",
    stroke: "white",
    strokeWidth: 2.30328,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79189 14.5716C8.22924 14.5716 8.58379 14.2197 8.58379 13.7858C8.58379 13.3518 8.22924 13 7.79189 13C7.35454 13 7 13.3518 7 13.7858C7 14.2197 7.35454 14.5716 7.79189 14.5716Z",
    stroke: "white",
    strokeWidth: 2.30328,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileinputIcon);
export default __webpack_public_path__ + "static/media/fileinput_icon.7c63e79c.svg";
export { ForwardRef as ReactComponent };